import React, { useState } from 'react';
import './Product.css';
import { useStateValue } from './StateProvider';

function Product({ id, title, image, price, rating }) {
  const [{ basket }, dispatch] = useStateValue();
  const [selectedSize, setSelectedSize] = useState(''); // State to track selected size

  // Calculate the discounted price based on the starting character of the ID
  let discountPercentage = 0; // Default to no discount
  if (id.startsWith('B')) {
    discountPercentage = 30; // 30% discount for 'B'
  } else if (id.startsWith('C')) {
    discountPercentage = 20; // 20% discount for 'C'
  } else if (id.startsWith('A')) {
    discountPercentage = 40; // 20% discount for 'C'
  }

  // Calculate the discounted price
  const discountedPrice = price - (price * discountPercentage) / 100;

  const addToBasket = () => {
    if (selectedSize === '') {
      alert('Please select a size before adding to the basket.');
      return;
    }

    dispatch({
      type: 'ADD_TO_BASKET',
      item: {
        id: id,
        title: title,
        image: image,
        price: discountedPrice, // Use the discounted price in the basket
        rating: rating,
        size: selectedSize, // Add the selected size to the basket item
      },
    });
  };

  const sizeOptions = ['S', 'M', 'L', 'XL', 'XXL'];

  return (
    <div className="product">
      <div className="product__info">
        <p>{title}</p>
        <p className="product__price">
          <small>₹</small>
          <strong>
            <span className={discountPercentage > 0 ? 'discounted' : ''}>
              {price}
            </span>
          </strong>
        </p>
        {discountPercentage > 0 && (
          <p className="product__discount">
            {discountPercentage}% Off: ₹{discountedPrice.toFixed(2)}
          </p>
        )}
        <div className="product__rating">
          {Array(rating)
            .fill()
            .map((_, i) => (
              <p key={i}>🌟</p>
            ))}
        </div>
      </div>

      <img src={image} alt="" />

      <div className="product__size">
        <p>Select Size:</p>
        <div className="size-options">
          {sizeOptions.map((size, index) => (
            <div
              key={index}
              className={`size-option ${
                selectedSize === size ? 'selected' : ''
              }`}
              onClick={() => setSelectedSize(size)}
            >
              {size}
            </div>
          ))}
        </div>
      </div>

      <button onClick={addToBasket}>Add to Basket</button>
    </div>
  );
}

export default Product;
